import { render } from "./ProductAdditionalInfo.vue?vue&type=template&id=42b41c64&scoped=true"
import script from "./ProductAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./ProductAdditionalInfo.vue?vue&type=script&lang=js"

import "./ProductAdditionalInfo.vue?vue&type=style&index=0&id=42b41c64&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b41c64"]])

export default __exports__